import { render, staticRenderFns } from "./trashModal.vue?vue&type=template&id=662ad22b&scoped=true"
import script from "./trashModal.vue?vue&type=script&lang=js"
export * from "./trashModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ad22b",
  null
  
)

export default component.exports